import { url as timelineUrl } from '../index';
import ApiService from '@api/api-service';

export const url = `${timelineUrl}`;
export default new ApiService(url);
